import React from 'react';

const SurveyContext = React.createContext({
  hasChatted: false,
  updateHasChatted: () => {}
});

export default SurveyContext;
